import { useLocation } from "react-router-dom";
import BssoPermissions from 'components/LM/Bsso/Permissions';
import VoiceSearch from "components/LM/Voice/Search/VoiceSearch";

function VoicesSearch() {
	const urlSearchParams = new URLSearchParams(useLocation().search)
	const searchParams = {
		term: urlSearchParams.get('term'),
		type: urlSearchParams.get('type'),
		channel: urlSearchParams.get('channel'),
		country: urlSearchParams.get('country')
	}

	return (
		<BssoPermissions permissions={["voices"]} behaviour="error">
			<VoiceSearch searchParams={searchParams} />
		</BssoPermissions>
	);
}

export default VoicesSearch;
